import {BlackoutDateProps, DAY} from "../../types/BlackoutPeriod";
import {hourToAMPM} from "../../utils/hourToAMPM";
import blackoutPeriodDay from "./BlackoutPeriodDay";
import {useContext} from "react";
import {BlackoutPeriodContext} from "./BlackoutPeriods";

interface BlackoutPeriodItemProps {
    day: DAY;
    hour: number;
    blackoutPeriod?: BlackoutDateProps;
    isHovered: boolean;
    occupiedColor: string;
}

const BlackoutPeriodItem = ({ day, hour, blackoutPeriod, occupiedColor, isHovered }: BlackoutPeriodItemProps) => {
    const { onBlackoutPeriodClick, onHoverOut, onHoverIn } = useContext(BlackoutPeriodContext);
    const isFirstDayOfBlackout = blackoutPeriod && blackoutPeriod.fromDay && day === blackoutPeriod.fromDay;
    const isFirstHourOfBlackout = blackoutPeriod && isFirstDayOfBlackout && blackoutPeriod.fromTime === hour;
    const isFirstHourInDayOfPreviousDayBlackout = blackoutPeriod && blackoutPeriod.fromDay && day > blackoutPeriod.fromDay && hour === 0;
    const isFirstBlackoutView = isFirstHourOfBlackout || isFirstHourInDayOfPreviousDayBlackout;
    const isBlackoutStartsAtDay = blackoutPeriod && blackoutPeriod.fromDay === day;
    const isBlackoutEndsAtDay = blackoutPeriod && blackoutPeriod.toDay === day;
    const isOneDayBlackout = isBlackoutStartsAtDay && isBlackoutEndsAtDay;
    const isStartDayNotEndDay = blackoutPeriod?.toDay && blackoutPeriod?.fromDay && blackoutPeriod.fromDay === day && blackoutPeriod.toDay !== day || false;
    const isEndDayNotStartDay = blackoutPeriod?.toDay && blackoutPeriod?.fromDay && blackoutPeriod.fromDay !== day && blackoutPeriod.toDay === day || false;
    const isNotStartDayNotEndDay = blackoutPeriod?.toDay && blackoutPeriod?.fromDay
        && (
            (blackoutPeriod.fromDay < day && blackoutPeriod.toDay > day)
            || (blackoutPeriod.fromDay < day && blackoutPeriod.toDay < day && blackoutPeriod.fromDay > blackoutPeriod.toDay)
        )
        || false;
    const sameDayBlackoutDailyHourCount = blackoutPeriod && blackoutPeriod.toTime - blackoutPeriod.fromTime || 0;
    const startDayNotEndDayBlackoutDailyHourCount = blackoutPeriod && 24 - blackoutPeriod.fromTime || 0;
    const EndDayNotStartDayBlackoutDailyHourCount = blackoutPeriod && blackoutPeriod.toTime || 0;
    const NotStartDayNotEndDayBlackoutDailyHourCount = 24;
    const blackoutLengthToday =
        isOneDayBlackout ? sameDayBlackoutDailyHourCount :
            isStartDayNotEndDay ? startDayNotEndDayBlackoutDailyHourCount :
                isEndDayNotStartDay ? EndDayNotStartDayBlackoutDailyHourCount :
                    isNotStartDayNotEndDay ? NotStartDayNotEndDayBlackoutDailyHourCount : 0;

    const isSingle = (
        blackoutPeriod && (
            (
                blackoutPeriod.toTime === blackoutPeriod.fromTime + 1
                && blackoutPeriod.toDay === blackoutPeriod.fromDay
            ) || (
                blackoutPeriod.fromTime === 23
                && day === blackoutPeriod.fromDay
            )
        )
    );

    const isDouble = (
        blackoutPeriod && (
            (
                blackoutPeriod.toTime === blackoutPeriod.fromTime + 2
                && blackoutPeriod.toDay === blackoutPeriod.fromDay
            ) || (
                blackoutPeriod.fromTime >= 22
                && day === blackoutPeriod.fromDay
            )
        )
    );

    return (
        <div className="blackout-period-item">
            {(blackoutPeriod?.id && (isFirstBlackoutView || (blackoutLengthToday === 24 && hour === 0) || (isEndDayNotStartDay && hour === 0))) ?
                <div
                    id={blackoutPeriod?.id?.toString()}
                    className={`occupied ${isSingle ? 'single' : ''} ${isHovered ? 'hovered' : ''} ${!isSingle && isDouble ? 'double' : ''}`}
                    style={{ height: `${blackoutLengthToday*18}px` }}
                    onClick={onBlackoutPeriodClick(blackoutPeriod.id)}
                    onMouseEnter={onHoverIn(blackoutPeriod?.id)}
                    onMouseLeave={onHoverOut(blackoutPeriod?.id)}
                >
                    <div style={{ backgroundColor: occupiedColor }}>
                        <div>{hourToAMPM(blackoutPeriod?.fromTime)} - {hourToAMPM(blackoutPeriod?.toTime)}</div>
                        {blackoutLengthToday > 4 ? <div className="title">{blackoutPeriod?.title}</div> : null}
                    </div>
                </div>
                : null}
        </div>
    )
}

export default BlackoutPeriodItem;